// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import './assets/styles/reset.css'
import './assets/styles/common.css'
import './assets/styles/mystyle.css'
import config from '@/config/env'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$imgServer = config.imgServer
Vue.prototype.$baseUrl = config.apiBaseUrl
Vue.prototype.$limitLength = config.limitLength

let token = sessionStorage.getItem('token')
if (!token) {
  token = ''
}
Vue.prototype.$token = token

const memberLeveTypeArr = [
  { value: 99, label: '普通用户' },
  { value: 1, label: '会员' },
  { value: 2, label: '内部员工' },
  { value: 3, label: '合伙人' }
]

import Editor from '@/components/Editor'
import Pagination from '@/components/Pagination'
import UploadImg from '@/components/UploadImg'
import UploadFile from '@/components/UploadFile'

Vue.component('Editor', Editor)
Vue.component('Pagination', Pagination)
Vue.component('UploadImg', UploadImg)
Vue.component('UploadFile', UploadFile)

Vue.prototype.$memberLeveTypeArr = memberLeveTypeArr

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js